class IntlSegmenterImpl {
    lang;
    grapheme;
    word;
    sentence;
    constructor(lang) {
        this.lang = lang;
        this.grapheme = new Intl.Segmenter(lang, { granularity: 'grapheme' });
        this.word = new Intl.Segmenter(lang, { granularity: 'word' });
        this.sentence = new Intl.Segmenter(lang, { granularity: 'sentence' });
    }
    graphemes(text) {
        return collect(this.grapheme, text);
    }
    words(text) {
        return [...this.word.segment(text)].map((s) => ({
            segment: s.segment,
            index: s.index,
            isWordLike: s.isWordLike,
        }));
    }
    sentences(text) {
        return collect(this.sentence, text);
    }
}
function collect(segmenter, text) {
    return [...segmenter.segment(text)].map((s) => ({ segment: s.segment, index: s.index }));
}
let overrideFactory = null;
export function setSegmenterFactory(factory) {
    overrideFactory = factory;
}
/**
 * D-2 seam: Hermes does not reliably ship Intl.Segmenter (soul.md §7), so all
 * segmentation goes through this factory. The bundled fallback implementation
 * is a P0.5 decision — when it lands, this factory picks Intl vs fallback per
 * runtime capability. Nothing outside this module may touch Intl.Segmenter.
 */
export function createSegmenter(lang) {
    if (overrideFactory !== null)
        return overrideFactory(lang);
    return new IntlSegmenterImpl(lang);
}
//# sourceMappingURL=segmenter.js.map